import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/widget-creator",
  },
  {
    path: "/widget-creator",
    name: "widgetCreator",
    component: () => import("../components/WidgetCreator.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/widget-creator",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
